export default "/images/delete.svg?378d191bd09847cfddf1156e51271858";